import queryString from 'query-string';
import { useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Loading from '../components/Loading';
import Cookies from 'js-cookie';
import { useAuth } from '../auth/Auth';

const SocialAuth = () => {
  let location = useLocation();
  const navigate = useNavigate();
  const { getUser } = useAuth();

  useEffect(() => {
    const values = queryString.parse(location.search);
    const azuread_token = values.azuread_token ? values.azuread_token : null;
    const slack_token = values.slack_token ? values.slack_token : null;
    const tokens = values.tokens ? values.tokens : null;
    const email = values.email ? values.email : null;
    const backend_name = values.provider ? values.provider : null;

    try {
      // Check if there's already a different user logged in before processing new auth
      const currentUser = getUser();
      const newUserEmail = typeof email === 'string' ? email : (email ? JSON.stringify(email) : null);
      const shouldClearIntegrationCookies = currentUser && newUserEmail && currentUser !== newUserEmail;

      if (shouldClearIntegrationCookies) {
        Cookies.remove('slack_access_token', { path: '/' });
        Cookies.remove('fireflies_access_token', { path: '/' });
      }

      // Parse and store tokens if they exist
      if (backend_name === 'azuread-oauth2') {
        if (tokens && typeof tokens === 'string') {
          // Convert single quotes to double quotes for valid JSON
          const tokensJsonString = tokens.replace(/'/g, '"');
          const parsedTokens = JSON.parse(tokensJsonString);
          window.localStorage.setItem("tokens", JSON.stringify(parsedTokens));
        }

        // Store email if available
        if (email) {
          window.localStorage.setItem("user", newUserEmail || "");
        }
      }

      // Handle Azure AD token (only set if not cleared above)
      if (azuread_token && !shouldClearIntegrationCookies) {
        Cookies.set('azuread_token', azuread_token as string, { path: '/', expires: 3 });
      }

      // Handle Slack token (only set if not cleared above)
      if (slack_token && !shouldClearIntegrationCookies) {
        Cookies.set('slack_access_token', slack_token as string, { path: '/', expires: 3 });
      }

    } catch (error) {
      console.error('Error parsing authentication data:', error);
    }

    const redirectPath = location.state?.path || '/'
    navigate(redirectPath)

  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <Loading />
      <p style={{ marginTop: '16px' }}>Just a moment</p>
    </div>
  );
};

export default SocialAuth;